import { render, staticRenderFns } from "./StadiumBoostLocalCustomersCreateAndUpdateFormItems.vue?vue&type=template&id=ba215ed0&"
import script from "./StadiumBoostLocalCustomersCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./StadiumBoostLocalCustomersCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
import style0 from "./StadiumBoostLocalCustomersCreateAndUpdateFormItems.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba215ed0')) {
      api.createRecord('ba215ed0', component.options)
    } else {
      api.reload('ba215ed0', component.options)
    }
    module.hot.accept("./StadiumBoostLocalCustomersCreateAndUpdateFormItems.vue?vue&type=template&id=ba215ed0&", function () {
      api.rerender('ba215ed0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StadiumBoostLocalCustomersCreateAndUpdateFormItems.vue"
export default component.exports